import { render, staticRenderFns } from "./DashboardReleaseNotes.vue?vue&type=template&id=823327f2&scoped=true"
import script from "./DashboardReleaseNotes.vue?vue&type=script&lang=js"
export * from "./DashboardReleaseNotes.vue?vue&type=script&lang=js"
import style0 from "./DashboardReleaseNotes.vue?vue&type=style&index=0&id=823327f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "823327f2",
  null
  
)

export default component.exports